import { render, staticRenderFns } from "./EmailAuthenticationPage.vue?vue&type=template&id=48557856"
import script from "./EmailAuthenticationPage.vue?vue&type=script&lang=ts"
export * from "./EmailAuthenticationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports